<template>
<div class="col in-the-news">
    <h3 class="section-heading" v-html="section.name"></h3>
    <ul class="items">
        <template v-for="(post, item_index) in section.posts"  >
            <li class="item" :key="post.id"  v-if="(item_index+1) <= section.item_limit">
                <div class="item-title">
                    <a :href="post.url">{{post.title}}</a>
                </div> 
                <div class="item-author">{{post.byline}}</div> 
            </li>
        </template>
    </ul>
    <div v-if="section.item_limit < section.posts.length" 
        class="load-more" @click="displayMorePostsForSection(section)">Load More</div>
</div> <!--End of col 1-->
</template>

<script>

import SectionsMixin from './SectionsMixin.js';

export default {
    name: 'general-section',
    mixins: [
        SectionsMixin,
    ],
}
</script>